// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustBoxesItem_container__pj8NP","heading":"TrustBoxesItem_heading__EyN9_","text":"TrustBoxesItem_text__kwfjt","icon":"TrustBoxesItem_icon__C_kdK"};